import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Card, Accordion, Button } from 'react-bootstrap';
import prof from '../../../../assets/images/prof.svg';
import './JobApplicants.css';
import { MdArrowDropDown } from 'react-icons/md';
function SelectedApplicants(props) {
	let url = window.location.href;
	const id = url.split('/').reverse()[1];
	const navigate = useNavigate();

	const viewProfileHandler = item => {
		navigate(`/job/${id}/applicants/view-profile`, {
			params: { profile: item },
		});
	};
	return (
		<div style={{ height: 'auto' }}>
			<h6 className='title '>Selected Applicants</h6>
			<Row className='cards-container'>
				{props.data.map((item, i) => {
					return (
						<Accordion key={i}>
							<Card className='accordion-card'>
								<Accordion.Toggle
									as={Button}
									variant='link'
									eventKey='0'
									style={{ background: 'lightgrey' }}
								>
									<div style={{ display: 'flex' }}>
										<h6 style={{ marginRight: '5px' }}>
											ID: {item.id} &nbsp;|| Name: {item.fullname}
										</h6>
										<MdArrowDropDown
											style={{ fontSize: '30px', marginLeft: '69%' }}
										/>
									</div>
								</Accordion.Toggle>
								<Accordion.Collapse eventKey='0'>
									<Card className='applicant-card'>
										<Card.Body>
											<Row className='row' style={{ width: '150%' }}>
												<img
													className='profile-img'
													src={item.profile_image ? item.profile_image : prof}
													alt='profile'
												/>
												<Col lg={8}>
													<h6 className='name'>{item.fullname}</h6>
													<p
														style={{
															fontSize: '12px',
															fontWeight: '600',
															marginTop: '-5px',
														}}
													>
														ID: {item.id}
													</p>
													{/* <p className="" style={{fontSize:'10px',marginTop:'-4px'}}>Engineer</p> */}
												</Col>
												<Col
													lg={3}
													style={{ display: 'flex', justifyContent: 'center' }}
												>
													<button
														className='btn-download-resume p-2'
														onClick={() => viewProfileHandler(item)}
													>
														View member Profile
													</button>
												</Col>
											</Row>
										</Card.Body>
									</Card>
								</Accordion.Collapse>
							</Card>
						</Accordion>
					);
				})}
			</Row>
		</div>
	);
}

export default SelectedApplicants;
